
import { useLocationField } from "components/layout/event/new/hooks/useLocationField";
import { SearchSelect } from "components/layout/forms/fields/Autocomplete/SearchSelect";
import { useFeatureFlags } from "components/providers/featureFlags/useFeatureFlags";
import { useTranslate } from "components/providers/LocalizationProvider";
import { Location } from "graphql/generated/types";
import { useFirstRender } from "hooks/useFirstRender";
import { useEffect, useState } from "react";

type RawPlacePrediction = {
    placeId: string;
    text: { toString(): string };
    toPlace(): { fetchFields(): Promise<any> };
}

export const LocationSearch: React.FC<{ onChange?: (value: Location | null) => void }> = ({ onChange }) => {
    const [data, setData] = useState<Location | null>(null);
    const [location, setLocation] = useState<{label: string, value: RawPlacePrediction} | Location | null>(null);
    const { options, autocompleteProps, loading } = useLocationField({
        value: (location as any)?.value || "",
        dateField: null,
        getValue: (value: any) => value,
        getInitialValueLabel: (value: any) => value?.placePredictionText || value?.text?.toString() || "",
        setValue: setData,
        name: "location"
    });
    
    const isFirstRender = useFirstRender();
    useEffect(() => {
        if (isFirstRender) return;
        onChange?.(data);
    }, [data]);

    const placeholder = useTranslate("Any location");
    const isLocationSearchEnabled = useFeatureFlags("Location Search");
    if (!isLocationSearchEnabled) return null;
    
    const field = {
        name: "location",
        loading,
        options,
        placeholder,
        autocompleteProps: {
            ...autocompleteProps,
            getOptionLabel: (option: any) => {
                return option?.label || option?.placePredictionText || option?.text?.toString() || "";
            },
        },
    };

    const input = {
        value: "location",
        onChange: setLocation
    };

    return <SearchSelect field={field} input={input} />;
};
